import "../Ledger/Ledger.scss";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { useState, useEffect, useContext } from "react";
import _axios from "../../../httpService";
import { toast } from "react-toastify";
import ObjectDataHolder from "../../Hooks/ObjectDataHolder";
import { useNavigate } from "react-router-dom";
import { SetPrintDataContext } from "../../../Pages";
import Loader from "../../Loader";

const GeneralLedger = () => {
  const [docNum, setDocNum] = useState("");
  const [docDate, setDocDate] = useState("");
  const prefixUrl = localStorage.getItem("apiUrl");
  const [documentCodes, setDocumentCodes] = useState([]);
  const [filterCode, setFilterCode] = useState([]);
  const [sendData, setSendData] = ObjectDataHolder();
  const [order, setOrder] = useState("");
  const [generalCode, setGeneralCode] = useState([]);
  const [id, setId] = useState([]);
  const [accountBase, setAccountBase] = useState("");
  const setTableData = useContext(SetPrintDataContext);
  const [isLoading, setIsLoading] = useState(false);

  const documentCodeHandler = (e) => {
    setDocNum(e.target.value);
    setSendData({ codeFilter: e.target.value });
    e.target.value === "range" &&
      _axios
        .get(prefixUrl + "/accountingLedger/?request=documentCodeList")
        .then((res) => {
          const data = res.data.data;
          setDocumentCodes(data);
        });
  };
  useEffect(() => {
    _axios
      .get(prefixUrl + "/accountingLedger/?request=mainCodeList")
      .then((res) => {
        const data = res.data.data;
        setGeneralCode(data);
      });
  }, []);
  const checkCodeNum = (e) => {
    const index = filterCode.findIndex((obj) => obj.name === e.target.name);

    if (index !== -1) {
      filterCode[index] = { name: e.target.name, value: e.target.value };
    } else {
      setFilterCode((prevArray) => [
        ...prevArray,
        { name: e.target.name, value: e.target.value },
      ]);
    }
    if (documentCodes && !documentCodes.includes(+e.target.value)) {
      toast.error("لطفا کد سند را درست وارد کنید");
    }
    let firstCodeValue;
    let lastCodeValue;
    if (filterCode.length === 2) {
      for (let code of filterCode) {
        if (code.name === "firstCode") {
          firstCodeValue = parseInt(code.value);
        } else if (code.name === "lastCode") {
          lastCodeValue = parseInt(code.value);
        }
      }

      if (firstCodeValue > lastCodeValue) {
        toast.error("عدد اول باید کوچکتر از عدد دوم باشد");
      }
    }
  };
  const datechangeHandler = (e) => {
    setDocDate(e.target.value);
    setSendData({ dateFilter: e.target.value });
  };
  const navigate = useNavigate();
  useEffect(() => {
    if (accountBase === "all") {
      setId("all");
    }
  }, [accountBase]);
  const sendDataHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (accountBase === "") {
      toast.error(" نوع انتخاب حساب را وارد کنید");
      return;
    }
    if (id.length === 0) {
      toast.error(" حساب را انتخاب کنید");
      return;
    }
    if (order === "") {
      toast.error("ترتیب گزارش را وارد کنید");
      return;
    }
    if (docNum === "") {
      toast.error("دسته بندی شماره سند را وارد کنید");
      return;
    }
    if (docNum === "range" && (!sendData.firstCode || !sendData.lastCode)) {
      toast.error("شماره سند را وارد کنید");
      return;
    }
    if (docDate === "") {
      toast.error(" دسته بندی تاریخ را وارد کنید");
      return;
    }
    if (docDate === "range" && (!sendData.startDate || !sendData.endDate)) {
      toast.error(" تاریخ را وارد کنید");
      return false;
    }
    _axios
      .get(
        prefixUrl +
          "/accountingLedger/?request=general&filters=" +
          JSON.stringify(sendData) +
          "&order=" +
          JSON.stringify(order.order) +
          "&id=" +
          id
      )
      .then((res) => {
        const data = res.data.data;
        data.name = "دفتر کل";
        data.title = "general";

        setTableData(data);
        setTimeout(() => {
          setIsLoading(false);

          navigate("/coding/LedgerTable");
        }, 2000);
      });
  };
  return !isLoading ? (
    <div className="ledger">
      <form>
        <div className="divgroup">
          <label className="form-check-label" htmlFor={"rnd1"}>
            انتخاب حساب
          </label>
          <select
            defaultValue={"nullSelect"}
            className="form-select form-select mb-2"
            aria-label=".form-select-lg example"
            name="accountbase"
            onChange={(e) => setAccountBase(e.target.value)}
          >
            <option selected hidden>
              بر اساس
            </option>
            <option value="all">همه</option>

            <option value="name">نام حساب </option>
            <option value="code"> کد حساب </option>
          </select>
        </div>
        {accountBase === "code" ? (
          <div className="divgroup">
            <label className="form-check-label" htmlFor={"rnd1"}>
              کد کل
            </label>
            <select
              defaultValue={"nullSelect"}
              className="form-select form-select mb-2"
              aria-label=".form-select-lg example"
              name="order"
              onChange={(e) => setId(e.target.value)}
            >
              <option selected hidden>
                کد کل را انتخاب کنید
              </option>
              {generalCode.map((item) => {
                return <option value={item.id}>{item.mainCode}</option>;
              })}
            </select>
          </div>
        ) : accountBase === "name" ? (
          <div className="divgroup">
            <label className="form-check-label" htmlFor={"rnd1"}>
              نام حساب کل
            </label>
            <select
              defaultValue={"nullSelect"}
              className="form-select form-select mb-2"
              aria-label=".form-select-lg example"
              name="order"
              onChange={(e) => setId(e.target.value)}
            >
              <option selected hidden>
                نام حساب کل را انتخاب کنید
              </option>
              {generalCode.map((item) => {
                return <option value={item.id}>{item.name}</option>;
              })}
            </select>
          </div>
        ) : (
          <></>
        )}
        <div className="divgroup">
          <label className="form-check-label" htmlFor={"rnd1"}>
            ترتیب گزارش
          </label>
          <select
            defaultValue={"nullSelect"}
            className="form-select form-select mb-2"
            aria-label=".form-select-lg example"
            name="order"
            onChange={(e) => setOrder({ order: e.target.value })}
          >
            <option selected hidden>
              بر اساس
            </option>
            <option value="documentCode">شماره سند </option>
            <option value="date">تاریخ سند </option>
          </select>
        </div>
        <div className="divgroup">
          <label className="form-check-label" htmlFor={"rnd1"}>
            شماره سند
          </label>
          <select
            defaultValue={"nullSelect"}
            className="form-select form-select mb-2"
            aria-label=".form-select-lg example"
            name="documentCode"
            onChange={documentCodeHandler}
          >
            <option selected hidden>
              انتخاب کنید
            </option>
            <option value="all"> همه </option>
            <option value="range"> محدوده </option>
          </select>
        </div>
        {docNum === "range" && (
          <div className="dis-flex">
            <div className="divgroup">
              <label className="form-check-label" htmlFor={"rnd1"}>
                از شماره
              </label>
              <input
                type="search"
                className="form-control newinput"
                name="firstCode"
                autoComplete="off"
                onBlur={checkCodeNum}
                onChange={(e) => setSendData({ firstCode: e.target.value })}
              />
              {/* <datalist defaultValue={""} id="factorPageProductList">
            <option value={""} />
            {searchDataList.map((value, index) => (
              <div key={index}>
                <option value={value} />
              </div>
            ))}
          </datalist> */}
            </div>
            <div className="divgroup">
              <label className="form-check-label" htmlFor={"rnd1"}>
                تا شماره
              </label>
              <input
                type="search"
                className="form-control newinput"
                name="lastCode"
                autoComplete="off"
                onBlur={checkCodeNum}
                onChange={(e) => setSendData({ lastCode: e.target.value })}
              />
            </div>
          </div>
        )}

        <div className="divgroup">
          <label className="form-check-label" htmlFor={"rnd1"}>
            تاریخ
          </label>
          <select
            defaultValue={"nullSelect"}
            className="form-select form-select mb-2"
            aria-label=".form-select-lg example"
            name="dateFilter"
            onChange={datechangeHandler}
          >
            <option selected hidden>
              بر اساس
            </option>
            <option value="all"> همه</option>
            <option value="range"> محدوده </option>
          </select>
        </div>
        {docDate === "range" && (
          <div className="dis-flex">
            <div className="divgroup">
              <label className="form-check-label" htmlFor={"rnd1"}>
                از تاریخ
              </label>
              <div className="form-control">
                <DatePicker
                  style={{ fontSize: "12px" }}
                  id={"dateHereForm"}
                  calendar={persian}
                  className="classNameOfDatePicker"
                  placeholder="تاریخ"
                  name={"startDate"}
                  onChange={(date) => {
                    if (date) {
                      setSendData({ startDate: date.toLocaleString() });
                    } else {
                      setSendData({ date: "" });
                    }
                  }}
                  // onChange={(e) => setSendData({ startDate: e.target.value })}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  hideOnScroll
                  //   value={documentDate}
                  //   onChange={(DateObject) => {
                  //     const temp = numeric.p2e(DateObject.format())
                  //     onchangeValue("documentDate", temp)
                  //   }}
                />
              </div>
            </div>
            <div className="divgroup">
              <label className="form-check-label" htmlFor={"rnd1"}>
                تا تاریخ
              </label>
              <div className="form-control">
                <DatePicker
                  style={{ fontSize: "12px" }}
                  id={"dateHereForm"}
                  calendar={persian}
                  className="classNameOfDatePicker"
                  placeholder="تاریخ"
                  name={"endDate"}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  onChange={(date) => {
                    if (date) {
                      setSendData({ endDate: date.toLocaleString() });
                    } else {
                      setSendData({ date: "" });
                    }
                  }}
                  hideOnScroll
                  //   value={documentDate}
                  //   onChange={(DateObject) => {
                  //     const temp = numeric.p2e(DateObject.format())
                  //     onchangeValue("documentDate", temp)
                  //   }}
                />
              </div>

              {/* <datalist defaultValue={""} id="factorPageProductList">
            <option value={""} />
            {searchDataList.map((value, index) => (
              <div key={index}>
                <option value={value} />
              </div>
            ))}
          </datalist> */}
            </div>
          </div>
        )}
        <div className="text-center">
          <button className="btnCustom btnSubmit" onClick={sendDataHandler}>
            نمایش
          </button>
        </div>
      </form>
    </div>
  ) : (
    <Loader />
  );
};

export default GeneralLedger;
